// Új program felvételéhez elég egy új tételt hozzáadni ehhez a listához.
export const EXPERIENCE_PROGRAMS = [
  {
    slug: "4-napos-elmenyprogram",
    to: "/elmenyprogram",
    title: "4 napos",
    titleAccent: "élményprogram",
    menuLabel: "4 napos élményprogram",
    lead: "Négy nap, ahol az önismeret nem feltétlenül nehéz vagy fájdalmas út, hanem könnyed, szép és nőies kapcsolódás.",
    date: "2026. augusztus 6–9.",
    location: "Debrecen",
    image: "/images/elmenyprogram-hero.jpg",
    imageAlt: "Női kör, közös élmény, kapcsolódás — 4 napos élményprogram",
  },
];
